import { PropTypes } from 'prop-types';
import React from 'react';

function ForwardCall(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_4932_1165)">
        <path
          d="M19.5625 12.0001H11.5625"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M16.5332 8.97083L19.5628 12.0003L16.5332 15.0299"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M4.85922 18.428L4.86099 18.438C5.04595 19.2713 5.50968 20.0166 6.17556 20.5507C6.84144 21.0848 7.6696 21.3757 8.52321 21.3754L9.2645 21.3754C9.42872 21.3755 9.59133 21.3432 9.74306 21.2804C9.89479 21.2176 10.0327 21.1255 10.1488 21.0093C10.2649 20.8932 10.357 20.7553 10.4198 20.6036C10.4826 20.4519 10.5149 20.2893 10.5149 20.125L10.5137 16.9996C10.5138 16.8354 10.4815 16.6728 10.4186 16.5211C10.3558 16.3693 10.2637 16.2315 10.1476 16.1154C10.0315 15.9992 9.89362 15.9071 9.74189 15.8443C9.59016 15.7815 9.42754 15.7492 9.26332 15.7492C8.93186 15.7492 8.614 15.6175 8.37962 15.3831C8.14525 15.1487 8.01356 14.8309 8.01351 14.4994L8.0141 9.49959C8.01415 9.16814 8.14584 8.85027 8.38021 8.6159C8.61459 8.38152 8.93245 8.24983 9.26391 8.24978C9.42813 8.24983 9.59075 8.21753 9.74248 8.15471C9.89421 8.09189 10.0321 7.99978 10.1482 7.88366C10.2643 7.76754 10.3564 7.62968 10.4192 7.47795C10.4821 7.32622 10.5144 7.1636 10.5143 6.99938L10.5137 3.87456C10.5137 3.5431 10.382 3.22524 10.1476 2.99086C9.91323 2.75649 9.59536 2.6248 9.26391 2.62475L8.52203 2.62416C7.66845 2.62402 6.84035 2.9151 6.17459 3.4493C5.50882 3.9835 5.04522 4.72885 4.8604 5.56219L4.85804 5.57161C4.03685 9.81777 4.03725 14.182 4.85922 18.428Z"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_4932_1165">
          <rect fill="white" height="20" transform="translate(3.5 2)" width="17" />
        </clipPath>
      </defs>
    </svg>
  );
}

ForwardCall.propTypes = {
  fill: PropTypes.string.isRequired
};

export default ForwardCall;
